export default "__VITE_ASSET__DYMpst4T__"